<vc-button
    iconName="content_copy"
    ariaLabel="{{ 'Copy ' + value }}"
    [tooltip]="tooltipText"
    mode="icon"
    [tooltipPosition]="tooltipPosition"
    [iconColor]="iconColor"
    (trigger)="copyToClipboard($event)"></vc-button>
